import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OurAuthService } from 'app/core/auth/auth.service';

export const RoleGuard: CanActivateFn = (route) => {
  const auth = inject(OurAuthService);
  const router = inject(Router);

  const allowedRoles: string[] = route.data?.['roles'] ?? [];

  const userRole = auth.userRole;

  if (!allowedRoles.length) {
    return true;
  }

  if (!allowedRoles.includes(userRole)) {
    return router.parseUrl('/overview');
  }

  return true;
};
